import React from "react";
import { PropTypes } from "prop-types";
import { Text } from "@kui/foundations-react";
import Input from "../util/Input";
import Select from "../util/Select";

// "Additional Information" section of the Figma form:
// claiming entitlement (not used for RWA03) and the partner referral (evals only)
const AdditionalInfo = (props) => {
  const fe = props.fieldErrors || {};
  const showClaim = props.IsRWA03 === false;
  const showPartner = props.isEval;
  if (!showClaim && !showPartner) return null;

  return (
    <div className='AppSection regSection'>
      <Text kind='title/xs' asChild>
        <div role='heading' aria-level={3}>Additional Information</div>
      </Text>
      <div className='regRow regRow--2'>
        {showClaim && (
          <Select
            id='EntitlementAs'
            labelText='Claiming Entitlement as'
            optionValues={props.claimingEntitlementAsOptions}
            isRequired={true}
            value={props.claimingEntitlementAs}
            onChange={props.handleClaimingEntitlementAsChange}
            errorText={fe.claimingEntitlementAs}
          />
        )}
        {showPartner && (
          <Input
            labelText='Partner Referral'
            placeholder='Enter partner referral'
            isRequired={false}
            value={props.partnerValue}
            onChange={props.handlePartnerChange}
            maximumLength={35}
            readOnly={props.partnerValuePresent}
            datatip={
              props.isBCM
                ? undefined
                : "Please let us know if you were referred to this trial by a partner."
            }
          />
        )}
      </div>
    </div>
  );
};

AdditionalInfo.propTypes = {
  IsRWA03: PropTypes.bool.isRequired,
  isEval: PropTypes.bool,
  isBCM: PropTypes.bool,
  claimingEntitlementAsOptions: PropTypes.array.isRequired,
  handleClaimingEntitlementAsChange: PropTypes.func.isRequired,
  claimingEntitlementAs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  partnerValue: PropTypes.string,
  partnerValuePresent: PropTypes.bool,
  handlePartnerChange: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object,
};

export default AdditionalInfo;
